import { Button } from "@/components/ui/button";
import { usePathRoute } from "@/features/Prompt/ClientContext";
import { ThreadListPrimitive } from "@assistant-ui/react";
import { PlusIcon } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

/**
 * New thread button component
 * Creates a new conversation and removes any thread ID from URL
 */
export const ThreadListNew: FC = () => {
  const navigate = useNavigate();
  const path_route = usePathRoute();

  return (
    <ThreadListPrimitive.New asChild>
      <Button
        className="data-[active]:bg-muted hover:bg-muted flex items-center justify-start gap-1 rounded-lg px-2.5 py-2 text-start"
        variant="ghost"
        onClick={() => {
          navigate(`/${path_route}`);
        }}
      >
        <PlusIcon />
        New Thread
      </Button>
    </ThreadListPrimitive.New>
  );
};
